// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4316":"AdvancedListingBlockTemplate","4328":"Widgets","4416":"react-slick","5772":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"4316":"3d25038c","4328":"ac119948","4416":"3d25038c","5772":"ac119948"}[chunkId] + ".chunk.css";
};